import React, { useMemo, useState, useEffect } from 'react';
import {
  MaterialReactTable,
  createRow,
  useMaterialReactTable,
} from 'material-react-table';
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  darken,
  lighten,
  Grid,
  Typography,
  Snackbar,
  Alert,
  Autocomplete,
  TextField
} from '@mui/material';
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { useSelector } from "react-redux";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useLocation, useHistory } from "react-router-dom";
import {
  getMultipleActivities,
  getPlanningData,
  getWorkersFromBuilding,
  saveDSCEmployeePlan,
  getDSCEmployeePlanningData
} from "services/dsc";
import { findActivitiesWithPrimary, filterActs, getDisplayName, 
  initialRowData, exportHeader, getEmployeeActWeekTotal, deepArrayEqual, 
  getFormattedEmployeePlan } from "./utils";
import { useTranslation } from "react-i18next";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useDSCStyles } from "./styles";
import { CSVLink } from 'react-csv';
import moment from 'moment';
import ConfirmDialog from 'components/ConfirmDialog';

const AddEditEmployee = () => {
  const [creatingRowIndex, setCreatingRowIndex] = useState();
  const [validationErrors, setValidationErrors] = useState({});
  const [averageBy, setAverageBy] = React.useState({ name: "Monthly", id: "monthly" });
  const [primaryBuildingActs, setPrimaryBuildingActs] = useState([]);
  const [activities, setActivities] = useState([]);
  const [averages, setAverages] = useState({});
  const [existingPlans, setExistingPlans] = useState([]);
  const [workersData, setWorkersData] = useState({});
  const [workerOptions, setWorkersOptions] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen : false,
    title: "Confirmation",
    onConfirm: () => {},
    alertMsg : "Are you sure to delete this worker?"
  })
  const [disableSave, setDisableSave] = useState(false);
  const [isEmployeePlanExists, setIsEmployeePlanExists] = useState(false);
  const [existingEmployeePlan, setExistingEmployeePlan] = useState([]);
  const [employeePlanDocId, setEmployeePlanDocId] = useState(null);
  const [loading, setLoading] = useState(null);
  const [alert, setAlert] = useState({});
  const [disablePlan, setDisablePlan] = useState(false);

  const { t, i18n } = useTranslation();
  const history = useHistory();
  const queryClientApi = useQueryClient();
  const classes = useDSCStyles();
  const location = useLocation();
  const {state, search} = location;
  const searchParams = new URLSearchParams(search);
  const buildingId = searchParams.get("buildingId");
  const districtId = searchParams.get("districtId");
  const week = searchParams.get("week");
  const { user } = useSelector((state) => state.user.auth);

  useEffect (() => {
    // window.onbeforeunload = () => true;
    if(!districtId || !buildingId || !week){
      history.goBack()
    }else{
      setDisablePlan(moment(week)<moment().startOf('week'));
    }
    // const unblock = history.block((location, action) => {
    //   const currentData = table.getRowModel().rows.filter(rowModel => rowModel.depth >0).map(rowModel => rowModel.original);
    //   if (!deepArrayEqual(currentData, initialData)) {
    //     return window.confirm("Are you sure? The changes you made may not be saved!");
    //   }
    //   return true;
    // });
    // return () => {
    //   window.onbeforeunload = null;
    // //  unblock();
    // };
  }, [location, initialData])

  const goBack = () =>{
    history.goBack()
  }

  const getExportData = (event, done) =>{
    try{
      let dataToExport = [
        {activityName:t("other.dscLblActivities"), targetAPH:t("other.dscLblTarget"), average:t("other.dscLblAverage"), workerId:t("other.tlWorkerId"),
         day1ActivityCount:t("other.dscLblCount"), day1Hours:t("other.dscLblHours"), 
         day2ActivityCount:t("other.dscLblCount"), day2Hours:t("other.dscLblHours"), 
         day3ActivityCount:t("other.dscLblCount"), day3Hours:t("other.dscLblHours"), 
         day4ActivityCount:t("other.dscLblCount"), day4Hours:t("other.dscLblHours"), 
         day5ActivityCount:t("other.dscLblCount"), day5Hours:t("other.dscLblHours"),
         day6ActivityCount:t("other.dscLblCount"), day6Hours:t("other.dscLblHours"), 
         day7ActivityCount:t("other.dscLblCount"), day7Hours:t("other.dscLblHours"), 
         weekTotalActivityCount:t("other.dscLblCount"), weekTotalHours:t("other.dscLblHours"), 
        }
      ];
      table.getRowModel().rows.forEach(row => {
        const rowData = row.original ? row.original : {};
        if(rowData && row.depth > 0 && Object.keys(rowData).length > 0){
          for(let i=1; i<=7; i++){
            rowData[`day${i}ActivityCount`] = rowData[`day${i}ActivityCount`] ? rowData[`day${i}ActivityCount`] : 0;
            rowData[`day${i}Hours`] = rowData[`day${i}Hours`] ? rowData[`day${i}Hours`] : 0;
          }
          rowData['weekTotalActivityCount'] = rowData['weekTotalActivityCount'] ? rowData['weekTotalActivityCount'] : 0;
          rowData['weekTotalHours'] = rowData['weekTotalHours'] ? rowData['weekTotalHours'] : 0;
          // rowData['weekTotalStaff'] = rowData['weekTotalStaff'] ? rowData['weekTotalStaff'] : 0;

          dataToExport.push({...rowData})
        }
      });
      console.log("AddEditEmployee CSV", dataToExport);
      setExportData(dataToExport);
      done(true);
    }catch(err){
      console.log("err");
      done(false);
    }
  }

  const handleCloseSnackbar = (event, reason) => {
    // if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };

  const fetchPlanningData = async () =>{
    if (!buildingId || !districtId || !week) {
      return;
    }
    try{
      const plans = await getPlanningData(
        districtId,
        buildingId,
        week
      );
      setExistingPlans(plans);
      return plans;
    }catch(err){
      console.log("err");
      setExistingPlans([]);
      return ;
    }
  }

  const fetchEmployeePlanningData = async () =>{
    if (!buildingId || !districtId || !week) {
      return;
    }
    try{
      const empPlan = await getDSCEmployeePlanningData(districtId, buildingId, week);
      setExistingEmployeePlan(empPlan);
      if(empPlan && empPlan.length >0){
        setIsEmployeePlanExists(true);
      }
      return empPlan;
    }catch(err){
      console.log("err");
      setExistingEmployeePlan([]);
      setIsEmployeePlanExists(false);
      return ;
    }
  }

  const getBuildingActivities = async () => {
    try{
      const activityResponse = await getMultipleActivities(
        districtId,
        [buildingId]
      );
      const primarySelection = findActivitiesWithPrimary(
        buildingId,
        activityResponse
      );

      setPrimaryBuildingActs(primarySelection);
      
      const activityList = primarySelection.activities;
      if (!Array.isArray(activityList) || activityList.length == 0) {
        console.log("No Activities");
        setActivities([]);
        return ;
      }
      const acts = filterActs(activityList)
      setActivities(acts);
      console.log("AddEditEmployee", activityList);
      return {activityList: acts, allActivities: primarySelection};
    }catch(err){
      console.log("err", err);
      setActivities([]);
      return ;
    }
  }

  //READ hook (get users from api)
  function useGetUsers() {
    return useQuery({
      queryKey: ['users'],
      queryFn: async () => {
        //send api request here
        const data = [];
        const initialData = [];
        let employeePlanRows = {};
        const buildingPlan = await fetchPlanningData();
        if(buildingPlan && buildingPlan.length > 0){

          const savedBuildingPlan = buildingPlan[0];
          const { plan:{activityData={}, averages={}, customActData = [], productivityHrs =0}={}, docId } = savedBuildingPlan;

          // fetch building activities from location collection
          const { activityList= [], allActivities= {} } = await getBuildingActivities();

          // fetch existing saved employee plan from dscEmployeePlan collection
          const employeePlan = await fetchEmployeePlanningData();

          // format the existing employee plan data to table structure
          if(employeePlan && employeePlan.length >0){
            employeePlanRows = getFormattedEmployeePlan(employeePlan[0], productivityHrs);
            console.log("AddEditEmployee", employeePlanRows);
          }
          console.log("AddEditEmployee", activityList, buildingPlan, employeePlan);

          // format the existing building plan custom activity data to table structure
          if(customActData && customActData.length >0) {
            customActData.forEach((custActDetails, index) => {
              const activityName = custActDetails?.activityName;
              const targetAPH = custActDetails?.activityTarget;
              const average = custActDetails?.activityAverage;
              const weekPlan = custActDetails.dayPlan ? custActDetails.dayPlan : {}
              if(activityName && weekPlan){
                const customActivity = {
                  id: `customAct${index}`,
                  idNum: `customAct${index}`,
                  capacity: targetAPH,
                  name: activityName,
                  parentId: `customAct${index}`,
                  parentName: activityName,
                  isEnabled: true,
                  isParent: true
                }
                activityList.push(customActivity);
                averages[`customAct${index}`] = average;
                activityData[`customAct${index}`] = {...weekPlan}
              }
            })
          }

          // format the existing building plan activity data to table structure
          if(activityList && activityList.length >0) {
            activityList.forEach((actData, index) => {
              if(actData){
                const { id, idNum, capacity } = actData;
                const parentRow = { activityId: id };
                const actName = getDisplayName(actData, t, i18n);
                parentRow["activityName"] = actName;
                parentRow["targetAPH"] = capacity;
                parentRow["productivityHrs"] = productivityHrs;
                // const savedBuildingPlan = buildingPlan[0];
                // const { plan:{activityData={}, averages={}}={}, docId } = savedBuildingPlan;
                setAverages(averages);
                const currentActAverage = averages?.[id];
                parentRow["average"] = currentActAverage ? currentActAverage : 0;
                if(id && activityData && Object.keys(activityData).length > 0){
                  const currentActData = activityData[id] ? activityData[id] : {};
                  if(currentActData && Object.keys(currentActData).length > 0){
                    Object.keys(currentActData).forEach(day => {
                      const dayData = currentActData[day] ? currentActData[day] : {};
                      const { activityCount=0, hours=0, staff=0 } = dayData;
                      parentRow[`${day}ActivityCount`] = parseFloat(activityCount);
                      parentRow[`${day}Hours`] = parseFloat(hours);
                      parentRow[`${day}Staff`] = parseFloat(staff);
                    })
                  }
                }
                // initialData.push({...parentRow});
                if(employeePlanRows && employeePlanRows[id]){
                  const subRows = Array.isArray(employeePlanRows[id]) ? employeePlanRows[id] : [];
                  parentRow.subRows = [...subRows];
                  initialData.push(...subRows);
                }
                // console.log("AddEditEmployee row", parentRow)
                data.push({...parentRow});
              }
            })
          }
          const workers = await getWorkersFromBuilding(districtId, buildingId);
          setWorkersData(workers);
          setWorkersOptions(Object.keys(workers));
          console.log("AddEditEmployee, workers", workers)
        }
        setInitialData(initialData);
        return Promise.resolve(data);
      },
      refetchOnWindowFocus: false,
    });
  }

  const groupDayHeader = (title, dayNum) =>{
    return (
    <>
    {title}
      <Grid item>
        <Typography
        //  component="div"
          variant="subtitle2"
          className={classes.colDate}
          >
            {moment(week)
              .startOf("week")
              .add(dayNum, "days")
              .format("DD")}
          </Typography>
      </Grid>
    </>
    )}

  const enableDayEdit = (day) => {
    return `day${moment().day()+1}` <= day || moment(week) > moment().endOf('week');
  }

  const subColumns = (day, enable) =>  [
    {
      accessorKey: `${day}ActivityCount`,
      header: 'Count',
      size: 10,
      muiEditTextFieldProps:{
        //  required: true,
        error: !!validationErrors?.[`${day}ActivityCount`],
        onFocus:()=> setValidationErrors({
          ...validationErrors,
          [`${day}ActivityCount`]: undefined,
        }),
        type: 'number',
        //  variant: 'outlined',
        sx :{
          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                 display: "none",
                               },
          "& input[type=number]": {
                                 MozAppearance: "textfield",
                               },
          },
        onKeyDown:(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault(),
        // placeholder: '0'
      },
      enableColumnActions : false,
      enableSorting : false,
      enableEditing: (row) => row.depth>0 && enable && enableDayEdit(day) && !disablePlan,
      Cell : ({renderedCellValue}) => !renderedCellValue ? 0 : renderedCellValue,
      muiTableHeadCellProps: {
        sx: {
          fontWeight: 'normal'
        }
      } 
      // Footer: ({ table }) => table.getFilteredRowModel().rows.reduce((total, row) => {
      //   const value = row.getValue(`${day}ActivityCount`);
      //   console.log("value", value)
      //   const sum = total + isNaN(value) ? 0 : value;
      //   return  sum;
      // }, 0),
    },
    {
      accessorKey: `${day}Hours`,
      header: 'Hours',
      size: 10,
      muiEditTextFieldProps:{
      //  required: true,
        error: !!validationErrors?.[`${day}Hours`],
        onFocus:()=> setValidationErrors({
          ...validationErrors,
          [`${day}Hours`]: undefined,
        }),
        type: 'number',
        sx :{
          "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                   display: "none",
                                 },
         "& input[type=number]": {
                                   MozAppearance: "textfield",
                                 },
         },
         onChange: (event) => {
          const val = event.target.value;
          if(val){
            if(val >=0 && val <=24){
              setValidationErrors({
                ...validationErrors,
                [`${day}Hours`]: undefined,
              })
            }else{
              setValidationErrors({
                ...validationErrors,
                [`${day}Hours`]: "Hours should be valid",
              })
            }
          }
         },
         onKeyDown:(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault(),
         // placeholder: '0'
         // variant: 'outlined',
      },
      enableColumnActions : false,
      enableSorting : false,
      enableEditing: (row) => row.depth>0 && enable && enableDayEdit(day) && !disablePlan,
      muiTableBodyCellProps: ({row}) => ({
        sx: {
          borderRight : '1px solid rgb(224, 224, 224)',
          fontWeight: row.depth>0 ? 'normal' : 700
        }
      }),
      muiTableHeadCellProps: {
        sx: {
          borderRight : '1px solid rgb(224, 224, 224)',
          fontWeight: 'normal'
        }
      },
      Cell : ({renderedCellValue}) => !renderedCellValue ? 0 : renderedCellValue
      // Footer: ({ table }) => table.getFilteredRowModel().rows.reduce((total, row) => 
      //   (total + isNaN(row.getValue(`${day}Hours`))? 0 : row.getValue(`${day}Hours`) ).toFixed(1), 0),
    },
    // {
    //   accessorKey: `${day}Staff`,
    //   header: 'Staff',
    //   size: 30,
    //   muiEditTextFieldProps:{
    //     required: true,
    //     error: !!validationErrors?.[`${day}Staff`],
    //     onFocus:()=> setValidationErrors({
    //       ...validationErrors,
    //       [`${day}Staff`]: undefined,
    //     }),
    //     type: 'number',
    //   //  variant: 'outlined',
    //   },
    //   enableColumnActions : false,
    //   enableSorting : false,
    //   enableEditing: false,
    //   // Footer: ({ table }) => table.getFilteredRowModel().rows.reduce((total, row) => 
    //   //   (total + isNaN(row.getValue(`${day}Staff`)) ? 0 : row.getValue(`${day}Staff`)).toFixed(1), 0),
    // }
  ];

  const columns = useMemo(
    () => [
      {
        accessorKey: `activityId`,
        header: 'Activity Id',
        enableEditing: (row) => row.depth>0,
        size: 50
      },
      {
        id:'activityInfo',
        header: '',
        columns : [
          {
            accessorKey: `activityName`,
            header: 'Activity',
            enableEditing: false,
            size: 50,
            muiTableHeadCellProps: {
              sx: {
                fontWeight: 'normal'
              }
            } 
          }
        ]
        // Footer: "Total"
      },
      {
        id:'aph',
        header: '',
        columns : [
          {
            accessorKey: `targetAPH`,
            header: 'Target',
            enableEditing: false,
            size: 30,
            enableColumnActions : false,
            enableSorting : false,
            muiTableHeadCellProps: {
              sx: {
                fontWeight: 'normal'
              }
            } 
          }
        ]
        // Footer: "Total"
      },
      {
        id:'averageInfo',
        header: '',
        columns : [
          {
            accessorKey: `average`,
            header: 'Average',
            enableEditing: false,
            size: 30,
            enableColumnActions : false,
            enableSorting : false,
            muiTableHeadCellProps: {
              sx: {
                fontWeight: 'normal'
              }
            } 
          }
        ]// Footer: "Total"
      },
      {
        id:'workerInfo',
        header: '',
        filterVariant: 'autocomplete',
        columns : [
          {
            accessorKey: 'worker',
            header: 'Worker',
            size: 50,
            muiTableHeadCellProps: {
              sx: {
                fontWeight: 'normal'
              }
            },
            muiEditTextFieldProps:{
              required: true,
              error: !!validationErrors?.workerId,
              helperText: validationErrors?.workerId,
              // onFocus:()=> setValidationErrors({
              //   ...validationErrors,
              //   workerId: undefined,
              // }),
            },
            Edit: ({ cell, column, row, table }) => {
              const [selectedWorker, setSelectedWorker] = useState(row.original.workerDetails ? row.original.workerDetails : {});

              const onBlur = (event) => {
                row._valuesCache[column.id] = event.target.value;
                row._valuesCache['workerDetails'] = selectedWorker;
                row._valuesCache['workerId'] = selectedWorker?.workerId;
                console.log("AddEditEmployee onBlur", event.target.value, selectedWorker, row);
                if (row.id === 'mrt-row-create') {
                  table.setCreatingRow(row);
                } else {
                  table.setEditingRow(row);
                }
              };
              
              const autoCompleteOptions = Object.values(workersData);
              return (
              <>
                <Autocomplete
                  onBlur= {onBlur}
                  id= "workerId"
                  defaultValue={cell?.getValue()}
                  options= {autoCompleteOptions}
                  sx= {{ maxWidth: 300 }}
                  getOptionLabel={(option) => option.label ? option.label  : option}
                  isOptionEqualToValue = {
                    (option, value) => option === value 
                    || option.label === value 
                    || option.workerId === value
                  }
                  onChange={(event, value) => {
                    const {rowsById={}} = table.getCoreRowModel();
                    const { originalSubRows = [] } = rowsById[row?.parentId || row?.original?.parentRowId] || {};
                    if(!value){
                      setValidationErrors({...validationErrors, workerId: 'worker is required'});
                    }else if(originalSubRows.filter(subRow => subRow.workerId === value.workerId && (!row.parentId || row.activityId !== subRow.activityId)).length > 0){
                      setValidationErrors({...validationErrors, workerId: 'worker is already added!'});
                    }else{
                      setValidationErrors({...validationErrors, workerId: ''});
                    }
                    setSelectedWorker(value);
                  }}
                  renderInput= {(params) => <TextField 
                    error = {!!validationErrors?.workerId}
                    helperText = {validationErrors?.workerId}
                    // onFocus = {()=> setValidationErrors({
                    //   ...validationErrors,
                    //   workerId: undefined,
                    // })}
                    {...params} />}
                  size='small'
                />
              </>
              )
            },
            enableEditing: (row) => row.depth>0,
          }
      ]
      },
      {
        id:'sun',
        header: groupDayHeader('SUN', 0),
        columns: subColumns('day1', true)
      },
      {
        id:'mon',
        header: groupDayHeader('MON', 1),
        size : 50,
        columns: subColumns('day2', true)
      },
      {
        id:'tue',
        header: groupDayHeader('TUE', 2),
        size : 50,
        columns: subColumns('day3', true)
      },
      {
        id:'wed',
        header: groupDayHeader('WED', 3),
        columns: subColumns('day4', true)
      },
      {
        id:'thu',
        header: groupDayHeader('THU', 4),
        columns: subColumns('day5', true)
      },
      {
        id:'fri',
        header: groupDayHeader('FRI', 5),
        columns: subColumns('day6', true)
      },
      {
        id:'sat',
        header: groupDayHeader('SAT', 6),
        columns: subColumns('day7', true)
      },
      {
        id:'total',
        header: 'TOTAL',
        columns: subColumns('weekTotal', false)
      },
    ],
    [validationErrors, workerOptions],
  );

  const handleSavePlan = async () =>{
    try{
      setDisableSave(true);
      setLoading(true);
      const currentData = table.getRowModel().rows.filter(rowModel => rowModel.depth >0).map(rowModel => rowModel.original);
      console.log("AddEditEmployee Save", JSON.stringify(currentData));
      console.log("AddEditEmployee Save", deepArrayEqual(currentData, initialData));
      console.log("AddEditEmployee Save", JSON.stringify(initialData));
      const isPlanUpdated = !deepArrayEqual(currentData, initialData);
      if(isPlanUpdated){
        const subRows = [];
        const plan = {};
        table.getRowModel().rows.forEach(rowModel => {
          if(rowModel.depth > 0){
            const rowData = rowModel && rowModel.original ?  {...rowModel.original} : {};
            subRows.push(rowData);
            const workerId = rowData?.workerId
            const workerDetails = rowData.workerDetails ? rowData.workerDetails : {};
            if(workerId){
                const activityPlan = {};
                const activityId = rowData.parentId;
                activityPlan[activityId] = {};
                for(let i=1; i<=7; i++ ){
                  activityPlan[activityId][`day${i}`] = {};
                  activityPlan[activityId][`day${i}`].activityCount = rowData[`day${i}ActivityCount`] ? rowData[`day${i}ActivityCount`] : 0;
                  activityPlan[activityId][`day${i}`].hours = rowData[`day${i}Hours`] ? rowData[`day${i}Hours`] : 0;
                }
                activityPlan[activityId]['weekTotal'] = {};
                activityPlan[activityId]['weekTotal']['activityCount'] = rowData['weekTotalActivityCount'] ? rowData['weekTotalActivityCount'] : 0;
                activityPlan[activityId]['weekTotal']['hours'] = rowData['weekTotalHours'] ? rowData['weekTotalHours'] : 0;
                // activityPlan[activityId]['weekTotal']['staff'] = rowData['weekTotalStaff'] ? rowData['weekTotalStaff'] : 0;
              if(plan[workerId]){
                if(plan[workerId]['activities']){
                  plan[workerId]['activities'] = {...plan[workerId]['activities'] , ...activityPlan};
                }else{
                  plan[workerId]['activities'] = {};
                  plan[workerId]['activities'] = {...activityPlan};
                }
              }else{
                plan[workerId] = {};
                plan[workerId]['activities'] = {};
                plan[workerId]['activities'] = {...activityPlan};
                plan[workerId]['workerDetails'] = {...workerDetails};
              }
            }else{
              console.log("Worker Id missing", rowData);
            }
          }
        });
        const dataToSubmit = {
          actionBy: user.workerId,
          actionTS: moment().format(),
          version: 1,
          districtId: districtId,
          buildingId: buildingId,
          weekStartDate: week,
          employeesPlan : {...plan},
          activities: {...activities.reduce((obj, act)=> ({...obj, [act.id]: {...act, weekAverage:averages?.[act.id]}}), {})}
        }
        console.log("AddEditEmployee save", dataToSubmit);
        // const formatEmploy
        if(isEmployeePlanExists && existingEmployeePlan.length >0){
          const { docId, plan} = existingEmployeePlan[0];
          const result = await saveDSCEmployeePlan(dataToSubmit, plan, docId);
          setEmployeePlanDocId(docId);
          setIsEmployeePlanExists(true);
          setInitialData(currentData);
          console.log("Updated Document Id", result);
        }else{
          const docId = await saveDSCEmployeePlan(dataToSubmit);
          console.log("AddEditEmployee Save",docId, plan);
          setEmployeePlanDocId(docId);
          setIsEmployeePlanExists(true);
          setInitialData(currentData);
        }
        setAlert({
          message: "DSC Employee Plan Saved Successfully",
          severity: "success"
        })
        setOpenSnackbar(true);
      }else{
        setAlert({
          message: "No Changes to save the Plan",
          severity: "warning"
        })
        setOpenSnackbar(true);
      }
      setLoading(false);
      setDisableSave(false);
    }catch(err){
      console.log("DSC Employee Plan failed to Save.");
      setAlert({
        message: "DSC Employee Plan Save Failed. Please try again",
        severity: "error"
      })
      setOpenSnackbar(true);
      setLoading(false);
      setDisableSave(false);
    }
  }

  //   () => [
  //     {
  //       accessorKey: 'id',
  //       header: 'Id',
  //       enableEditing: false,
  //       size: 80,
  //     },
  //     {
  //       accessorKey: 'firstName',
  //       header: 'First Name',
  //       muiEditTextFieldProps: {
  //         required: true,
  //         error: !!validationErrors?.firstName,
  //         helperText: validationErrors?.firstName,
  //         //remove any previous validation errors when user focuses on the input
  //         onFocus: () =>
  //           setValidationErrors({
  //             ...validationErrors,
  //             firstName: undefined,
  //           }),
  //         //optionally add validation checking for onBlur or onChange
  //       },
  //     },
  //     {
  //       accessorKey: 'lastName',
  //       header: 'Last Name',
  //       muiEditTextFieldProps: {
  //         required: true,
  //         error: !!validationErrors?.lastName,
  //         helperText: validationErrors?.lastName,
  //         //remove any previous validation errors when user focuses on the input
  //         onFocus: () =>
  //           setValidationErrors({
  //             ...validationErrors,
  //             lastName: undefined,
  //           }),
  //       },
  //     },
  //     {
  //       accessorKey: 'city',
  //       header: 'City',
  //       muiEditTextFieldProps: {
  //         required: true,
  //         error: !!validationErrors?.city,
  //         helperText: validationErrors?.city,
  //         //remove any previous validation errors when user focuses on the input
  //         onFocus: () =>
  //           setValidationErrors({
  //             ...validationErrors,
  //             city: undefined,
  //           }),
  //       },
  //     },
  //     {
  //       accessorKey: 'state',
  //       header: 'State',
  //       editVariant: 'select',
  //       editSelectOptions: [],
  //       muiEditTextFieldProps: {
  //         select: true,
  //         error: !!validationErrors?.state,
  //         helperText: validationErrors?.state,
  //       },
  //     },
  //   ],
  //   [validationErrors],
  // );

  //call CREATE hook
  const { mutateAsync: createUser, isPending: isCreatingUser } =
    useCreateUser();
  //call READ hook
  const {
    data: fetchedUsers = [],
    isError: isLoadingUsersError,
    isFetching: isFetchingUsers,
    isLoading: isLoadingUsers,
    refetch
  } = useGetUsers();
  // {data:[], isError:false, isFetching: false, refetch:()=>{}};
  //call UPDATE hook
  const { mutateAsync: updateUser, isPending: isUpdatingUser } =
    useUpdateUser();
  //call DELETE hook
  const { mutateAsync: deleteUser, isPending: isDeletingUser } =
    useDeleteUser();

  //CREATE action
  const handleCreateUser = async ({ values, row, table }) => {
    const actvityWeekTotals = getEmployeeActWeekTotal(values);
    const {rowsById={}} = table.getCoreRowModel();
    const currentActParentRow = rowsById[row.original.parentRowId];
    const newValidationErrors = validateUser({...values, parentId: row.original.parentId, ...actvityWeekTotals}, currentActParentRow?.originalSubRows);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});
    await createUser({ ...values, parentId: row.original.parentId, ...actvityWeekTotals });
    table.setCreatingRow(null); //exit creating mode
    setDisableSave(false);
  };

  //UPDATE action
  const handleSaveUser = async ({ values, table, row }) => {
    console.log("AddEditEmployee handleSaveUser", values, row.original);
    const originalData = row.original ? row.original : {};
    const actvityWeekTotals = getEmployeeActWeekTotal(values);
    const newValidationErrors = validateUser({...originalData, ...values, ...actvityWeekTotals}, row?.getParentRow()?.originalSubRows);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});
    console.log("AddEditEmployee update", actvityWeekTotals);
    await updateUser({...originalData, ...values, ...actvityWeekTotals});
    table.setEditingRow(null); //exit editing mode
    setDisableSave(false);
  };

  //DELETE action
  const openDeleteConfirmModal = (row) => {
    setConfirmDialog({...confirmDialog, 
      isOpen: true, 
      subTitle: `Delete Employee - ${row.original.worker}`,
      onConfirm : async () => {
        await deleteUser(row.original.activityId);
        setConfirmDialog({...confirmDialog, isOpen: false});
      }
    });
  };

  const table = useMaterialReactTable({
    columns,
    data: fetchedUsers,
    createDisplayMode: 'row', // ('modal', and 'custom' are also available)
    editDisplayMode: 'row', // ('modal', 'cell', 'table', and 'custom' are also available)
    enableColumnPinning: true,
    enableEditing: (row) => row.depth>=0,
    enableExpanding: true,
    positionCreatingRow: creatingRowIndex, //index where new row is inserted before
    //enableStickyHeader: true,
    enableStickyFooter: true,
    getRowId: (row) => row.id,
    enablePagination : false,
    enableBottomToolbar: false,
    enableDensityToggle: true,
    enableRowActions : !disablePlan,
    muiToolbarAlertBannerProps: isLoadingUsersError
      ? {
          color: 'error',
          children: 'Error loading data',
        }
      : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: `calc(100vh - 280px)`,
        maxHeight: `calc(100vh - 220px)`
      },
    },
    muiTableHeadProps: {
      className: classes.tableHead,
    },
    muiTableBodyRowProps: ({ row }) => ({
      //conditional styling based on row depth
      sx: (theme) => ({
        backgroundColor: darken(
          lighten(theme.palette.background.paper, 0.1),
          row.depth * (theme.palette.mode === 'dark' ? 0.9 : 0.05),
        )
      }),
    }),
    muiTableBodyCellProps: ({row}) => ({
      sx: {
        fontWeight: row.depth>0 ? 'normal' : 700
      }
    }),
    onCreatingRowCancel: () => {
      setDisableSave(false);
      setValidationErrors({})
    },
    onCreatingRowSave: handleCreateUser,
    onEditingRowCancel: () => {
      setDisableSave(false);
      setValidationErrors({})
    },
    onEditingRowSave: handleSaveUser,
    renderRowActions: ({ row, staticRowIndex, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        {row.depth > 0 && <>
        <Tooltip title="Edit" placement='left'>
          <IconButton 
            disabled = {disablePlan}
            onClick={() => {
            console.log("edit row", row);
            setDisableSave(true);
            table.setEditingRow(row)
            }}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete" placement='right'>
          <IconButton disabled = {disablePlan} color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        </>}
       { row.depth === 0 &&
        <Tooltip title="Add Employee" placement='left'>
          <IconButton
            disabled = {disablePlan}
            onClick={() => {
                setDisableSave(true);
                table.setCreatingRow(null);
                setCreatingRowIndex((staticRowIndex || 0) + 1);
                table.setCreatingRow(
                  createRow(
                    table,
                    {
                      ...initialRowData,
                      id: null,
                      activityName: row.original.activityName,
                      parentId: row.original.activityId,
                      subRows: [],
                      average: row.original.average,
                      targetAPH: row.original.targetAPH,
                      parentRowId: row.id
                    },
                    -1,
                    row.depth + 1,
                  ),
                );
              }}
            >
            <PersonAddAltIcon />
          </IconButton>
        </Tooltip>}
      </Box>
    ),
    renderTopToolbarCustomActions: ({ table }) => (
      <Grid container style={{gap : "20px", alignItems: "flex-end", margin:"0 20px 0 20px", justifyContent: "space-between"}}>
        <Typography variant='h6'>
          Manage DSC Employees
        </Typography>
        <Grid item  style={{display:'inline-flex', gap: '30px'}}>
          <CSVLink
              data={exportData}
              asyncOnClick={true}
              onClick={getExportData}
              headers={exportHeader(week, t)}
              filename={`${buildingId}_DSC_Employee_Plan_${moment().format("DD-MM-YYYY")}`}
            >
            <Button
                //  onClick={handleExportData}
                //variant='none'
                color='primary'
                
                startIcon={<FileDownloadIcon />}
              >
                Export CSV
            </Button>
          </CSVLink>
          <Button
              onClick={handleSavePlan}
              variant='contained'
              color='primary'
              disabled = {disableSave || disablePlan}
              // startIcon={<FileDownloadIcon />}
            >
              Save
          </Button>
        </Grid>
      </Grid>
    ),
    initialState: {
      columnPinning: { left: ['mrt-row-actions'], right: [] },
      expanded: true,
      pagination: { pageSize: 20, pageIndex: 0 },
      columnVisibility: { activityId: false },
      density : 'compact'
    },
    state: {
      isLoading: isFetchingUsers,
      isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
      showAlertBanner: isLoadingUsersError,
      showProgressBars: isFetchingUsers || loading,
      // density: 'compact'
    },
    displayColumnDefOptions: {
      'mrt-row-expand': {
      //  enableResizing: true, //allow resizing
        size: 10, //make the expand column wider
      },
    }
  });

  return (
    <>
      <Grid container spacing={2} style={{marginBottom:"16px", marginLeft:"0px", width:"100%"}} alignItems="center">
        <Grid item >
          <IconButton aria-label="back"  onClick={goBack}>
              <ArrowBackIcon fontSize="medium" />
          </IconButton>
        </Grid>
        <Grid item >
          <Typography variant="subtitle1" >
            WEEK START DATE - <span className={classes.selectedValue}>{week}</span>
          </Typography>
        </Grid>
        <Grid item >
          <Typography variant="subtitle1" >
            DISTRICT - <span className={classes.selectedValue}>{districtId}</span>
          </Typography>
        </Grid>
        <Grid item >
        <Typography variant="subtitle1" >
            BUILDING - <span className={classes.selectedValue}>{buildingId}</span>
          </Typography>
        </Grid>
        </Grid>
      <MaterialReactTable table={table} />
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "top", }}
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        autoHideDuration={2000}
      >
        <Alert severity={alert.severity ? alert.severity : 'info' } variant="filled">
          {alert.message}
        </Alert>
      </Snackbar>
      <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog}> </ConfirmDialog>
  </>);
};

//CREATE hook (post new user to api)
function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (user) => {
      console.info('create user', user);
      //send api update request here
    //  await new Promise((resolve) => setTimeout(resolve, 100)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (newUserInfo) => {
      queryClient.setQueryData(['users'], (_prevUsers) => {
        const prevUsers = JSON.parse(JSON.stringify(_prevUsers));
        newUserInfo.subRows = [];
        if (newUserInfo.parentId) {
          const parentActivity = findnodeInTree(newUserInfo.parentId, prevUsers);
          if (parentActivity) {
            parentActivity.subRows = [
              {
                ...newUserInfo,
                activityId: `${parentActivity.activityId}.${(parentActivity.subRows?.length || 0) + 1}`,
              },
              ...(parentActivity.subRows || [])
            ];
          }
        } 
        // else {
        //   prevUsers.push({
        //     ...newUserInfo,
        //     id: `${prevUsers.length + 1}`,
        //   });
        // }
        return [...prevUsers];
      });
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
  });
}

//UPDATE hook (put user in api)
function useUpdateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (user) => {
      console.info('update user', user);
      //send api update request here
    //  await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (newUserInfo) => {
      console.log("AddEditEmployee update", newUserInfo);
      queryClient.setQueryData(['users'], (prevUsers) => {
        const newUsers = JSON.parse(JSON.stringify(prevUsers));
          const manager = findnodeInTree(newUserInfo.parentId, newUsers);
          if (manager) {
            manager.subRows = manager.subRows?.map(
              (subUser) => {
                if(subUser.activityId === newUserInfo.activityId){
                  subUser = {...subUser, ...newUserInfo}
                }
                return subUser
              }
            );
          } 
        console.log("AddEditEmployee update", newUsers);
        return [...newUsers];
      });
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
  });
}

//DELETE hook (delete user in api)
function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (userId) => {
      console.info('delete user', userId);
      //send api update request here
    //  await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (userId) => {
      queryClient.setQueryData(['users'], (prevUsers) => {
        const newUsers = JSON.parse(JSON.stringify(prevUsers));
        //remove user
        const user = findnodeInTree(userId, newUsers);
        if (user) {
          const manager = findnodeInTree(user.parentId, newUsers);
          if (manager) {
            manager.subRows = manager.subRows?.filter(
              (subUser) => subUser.activityId !== user.activityId,
            );
          } 
          // else {
          //   return newUsers.filter((user) => user.id !== userId);
          // }
        }
        return [...newUsers];
      });
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
  });
}

const queryClient = new QueryClient();

const AddEditEmployeeWithProviders = () => (
  <QueryClientProvider client={queryClient}>
    <AddEditEmployee />
  </QueryClientProvider>
);

export default React.memo(AddEditEmployeeWithProviders);

const validateRequired = (value) => !!value;

function validateUser(user, currentActSubRows=[]) {
  let errorMessage = 0;
  if(!user || !currentActSubRows){
    errorMessage = 1;
  }else{
    if(!validateRequired(user.workerId)){
      errorMessage = 2;
    }else if(currentActSubRows.filter((rowData) => user.workerId == rowData.workerId && (!user.activityId || user.activityId !== rowData.activityId )).length>0){
      errorMessage = 3;
      console.log("AddEditEmployee validateUser", errorMessage);
    }else if((!validateRequired(user.weekTotalActivityCount) || !validateRequired(user.weekTotalHours))){
      errorMessage = 4
    }
  }
  if(user.day1Hours > 24 || user.day2Hours > 24 || user.day3Hours > 24 || 
    user.day4Hours > 24 || user.day5Hours >24 || user.day6Hours > 24 || 
    user.day7Hours > 24){
    errorMessage = 5;
  }
    switch(errorMessage){
      case 1 : return {workerId: "Something went wrong"}
      case 2 : return {workerId: "Worker is required"}
      case 3 : return {workerId: "worker is already added!"}
      case 4 : return {workerId: "Please Enter Activity Count and Hours"}
      case 5 : return {workerId: "Daily hours should not exceed 24"}
      default : return {workerId : ''}
    }
}

function findnodeInTree(id, users) {
  for (let i = 0; i < users.length; i++) {
    if (users[i].activityId === id) {
      return users[i];
    }
    if (users[i].subRows) {
      const found = findnodeInTree(id, users[i].subRows);
      if (found) return found;
    }
  }
  return null;
}
